import React from "react";
import Card from "components/card";
import { Popover } from "antd";

const AwardCardCompact = ({
    title = "",
    date = "",
    icon: Icon,
    category = "",
    popoverContent = "",
}) => {
    return (
        <Card className="p-3 rounded-xl border-2 border-purple-200 bg-gradient-to-br from-purple-50 to-white hover:shadow-md transition-all">
            <div className="flex items-center gap-2 nomination">
                <Popover 
                    content={popoverContent} 
                    trigger="hover" 
                    placement="top"
                    overlayClassName="reward-popover"
                >
                    <div className={`w-8 h-8 !rounded-full icon-style ${category} shadow-lg border-2 border-white flex items-center justify-center cursor-pointer hover:scale-110 transition-transform`}>
                        {Icon && <Icon className="w-4 h-4 text-white" />}
                    </div>
                </Popover>
                <div className="flex-1">
                    <p className="text-[13px] font-semibold">{title}</p>
                    <p className="text-[10px] text-slate-700">{date}</p>
                </div>
            </div>
        </Card>
    );
};

export default AwardCardCompact;
